module.exports = __webpack_public_path__ + "img/ic_exercise.3334060e.png";